module.exports = __webpack_public_path__ + "img/2.7b7a9f62.png";